import * as nav from './configNav';
import * as portfolioConfig from './configPortfolio';
import { featuredClients } from './configFeaturedClients';
import { configServices } from './configServices';
import { configProcess } from './configProcess';
import { configReviews } from './configReviews';
import { configWhyUs } from './configWhyUs';
import { configEngagement } from './configEngagement';
import { configAiPrinciples } from './configAiPrinciples';

const env = process.env.REACT_APP_ENV;
const dev = process.env.REACT_APP_ENV === 'development';

// Canonical root url is needed in social media sharing and SEO optimization purposes.
// Falls back to localhost in development if the env var isn't set.
const canonicalRootURL =
  process.env.REACT_APP_CANONICAL_ROOT_URL ||
  process.env.REACT_APP_ROOT_URL ||
  'http://localhost:3000';

// Site title is needed in meta tags (bots and social media sharing reads those)
const siteTitle = 'gitribe';

// Twitter handle is needed in meta tags (twitter:site). Start it with '@' character
const siteTwitterHandle = '@codedvlpr';

// Instagram page is used in SEO schema (https://schema.org/Organization)
const siteInstagramPage = 'https://www.instagram.com/gitribe/';

// Facebook page is used in SEO schema (https://schema.org/Organization)
const siteFacebookPage = 'https://www.facebook.com/gitribe';

const siteLinkdinPage = 'https://www.linkedin.com/company/gitribe';

/**
 * Organization facts, used to build the Organization / ProfessionalService
 * JSON-LD in Page.js. Search engines treat this as the entity definition for
 * the business, so everything here must be true and must match what is said
 * elsewhere — the site, LinkedIn, and a Google Business Profile.
 *
 * `address` is intentionally absent: a postal address must be the real
 * registered one, and an invented or partial address is worse than none —
 * it fails verification and can suppress the listing. Add it here as a
 * PostalAddress once confirmed:
 *
 *   address: {
 *     '@type': 'PostalAddress',
 *     streetAddress: '…',
 *     addressLocality: '…',
 *     addressRegion: '…',
 *     postalCode: '…',
 *     addressCountry: 'PK',
 *   },
 */
const organization = {
  legalName: 'Gitribe',
  foundingDate: '2014',
  logoPath: '/static/icons/web-app-manifest-192x192.png',
  email: 'contact@gitribe.com',
  telephone: '+923054000453',
  address: undefined,

  knowsAbout: [
    'Custom software development',
    'AI agent development',
    'Machine learning engineering',
    'Web application development',
    'Mobile app development',
    'Marketplace development',
    'Cloud and DevOps',
    'UI/UX design',
  ],
};

const config = {
  env,
  dev,
  canonicalRootURL,
  siteTitle,
  siteFacebookPage,
  siteInstagramPage,
  siteTwitterHandle,
  siteLinkdinPage,
  organization,
  nav,
  portfolioConfig,
  featuredClients,
  configServices,
  configProcess,
  configReviews,
  configWhyUs,
  configEngagement,
  configAiPrinciples,
};

export default config;
